import React from 'react'

import styled from 'styled-components'

import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'

const CircularProgess = ({ step, maxSteps }) => {
  return (
    <StyledSidebar>
      <div className="in">
        <CircularProgressbar
          value={step}
          maxValue={maxSteps}
          text={`${step} of ${maxSteps}`}
          strokeWidth={maxSteps}
          styles={buildStyles({
            strokeLinecap: 'butt',
            textSize: '.8rem',
            pathTransitionDuration: 0.5,
            pathColor: `#FF5880`,
            textColor: '#31374F',
            trailColor: '#E9EBF2',
          })}
        />
      </div>
    </StyledSidebar>
  )
}

const StyledSidebar = styled.aside`
  width: 100%;
  max-width: 190px;
  margin-right: 4rem;
  position: sticky;
  top: 8rem;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #fff;
    top: 5rem;
  }

  @media (max-width: 768px) {
    background: #fff;
    max-width: 100vw;
    width: 100%;
    left: 0;
    right: 0;
    z-index: 3;

    .in {
      width: 100%;
      max-width: 120px;
    }
  }

  .sidebar-content {
    margin-top: 2rem;

    @media (max-width: 768px) {
      display: flex;
      align-items: flex-start;
    }
  }
`

export default CircularProgess
